import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

api.interceptors.request.use((cfg) => {
  const token = localStorage.getItem("srad_token");
  if (token) cfg.headers.Authorization = `Bearer ${token}`;
  return cfg;
});

export function formatApiError(err) {
  const d = err?.response?.data?.detail;
  if (!d) return err?.message || "Something went wrong";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((e) => e?.msg || JSON.stringify(e)).join(" · ");
  if (typeof d === "object" && d.msg) return d.msg;
  return String(d);
}

export const STATUS_STYLES = {
  draft: "bg-slate-100 text-slate-700",
  ready_for_dispatch: "bg-blue-50 text-blue-700",
  dispatched: "bg-indigo-50 text-indigo-700",
  in_transit: "bg-amber-50 text-amber-700",
  out_for_delivery: "bg-orange-50 text-orange-700",
  delivered: "bg-emerald-50 text-emerald-700",
  delivery_attempted: "bg-yellow-50 text-yellow-700",
  client_not_available: "bg-yellow-50 text-yellow-700",
  material_on_hold: "bg-slate-100 text-slate-700",
  delayed: "bg-rose-50 text-rose-700",
  returned: "bg-orange-100 text-orange-800",
  cancelled: "bg-slate-200 text-slate-700",
};

export const POD_STYLES = {
  not_required: "bg-slate-100 text-slate-700",
  pending: "bg-amber-50 text-amber-700",
  requested: "bg-indigo-50 text-indigo-700",
  received: "bg-emerald-50 text-emerald-700",
  verified: "bg-emerald-100 text-emerald-800",
};

export const DELIVERY_STATUSES = [
  "draft", "ready_for_dispatch", "dispatched", "in_transit", "out_for_delivery",
  "delivered", "delivery_attempted", "client_not_available", "material_on_hold",
  "delayed", "returned", "cancelled",
];

export const POD_STATUSES = ["not_required", "pending", "requested", "received", "verified"];

export function labelOf(s) {
  if (!s) return "";
  return s.split("_").map((w) => w[0].toUpperCase() + w.slice(1)).join(" ");
}
